import React from 'react';
import {HeroContainer, HeroContent, HeroH1, HeroP} from './HeroElement';

const HeroSection8 = () => {
  return (
    <HeroContainer>
      <HeroContent>
        <HeroH1>The BeST NFTs in the MeTAVeRSe Pop BeLLY NFT Collection</HeroH1>
        <HeroP>
          Heroes, villains, innovators, leaders, role models – these are just some of the different
          types of people that have graced our world. This NFT collection offers a wide variety of
          iconic individuals who have been extremely relevant in the world. Now you can own one of them in the form of
          very appealing NFT artwork.
        </HeroP>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection8;